export default __webpack_public_path__ + "69151469dfbb33bab62ba68932b5b671.svg";